import angularModule from 'Lessons/angularModule/scripts/lessons_module';
import { react2Angular } from 'FrontRoyalReact2Angular';
import { Footer } from 'Footer';

/*
    Registers the app's Footer under the `dashboardFooter` element name, so the Angular views that host
    it need no changes. Footer reads the institution's links itself; see useFooterUrls.
*/
angularModule.component('dashboardFooter', react2Angular(Footer));
